import { render, staticRenderFns } from "./SearchExpansion.vue?vue&type=template&id=753f93e6&"
import script from "./SearchExpansion.vue?vue&type=script&lang=js&"
export * from "./SearchExpansion.vue?vue&type=script&lang=js&"
import style0 from "./SearchExpansion.vue?vue&type=style&index=0&id=753f93e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports